import { render } from "./ToolbarListIcon.vue?vue&type=template&id=6120388b"
import script from "./ToolbarListIcon.vue?vue&type=script&lang=js"
export * from "./ToolbarListIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__